<template>
  <div id="wrapper">
    <div class="press-item-wrapper" v-for="item in items" :key="item.slug">
      <h3>{{ item.title }}</h3>
      <div class="item-details" v-html="item.text"></div>
      <router-link
        class="link"
        :to="{
          name: 'media-subsection',
          params: {
            section: 'press',
            subsection: item.slug,
            locale: $i18n.locale
          }
        }"
        @click.native="$emit('scrollToTop')"
        >{{ $t("media.readMore") }}
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: "PressReleaseCondensedView",
  props: ["items"]
};
</script>

<style scoped>
.item-details {
  font-size: 1em;
  line-height: 1.2em;
  height: 6em;
  overflow: hidden;
}

.press-item-wrapper {
  margin-bottom: 100px;
  border-bottom: 1px solid #b4b4b4;
}

.link {
  margin-top: 24px;
  padding: 14px 23px;
  border-style: solid solid none;
  border-width: 1px;
  border-color: #b4b4b4;
  background-color: #f0f0f0;
  color: #797979;
  font-size: 1em;
  line-height: 1.1em;
  font-weight: 300;
  display: inline-block;
  text-decoration: none;
}

.link:hover {
  text-decoration: none;
  background-color: black;
  color: white;
}
</style>
